import React, { useState } from "react";
import Card from "../Card";
import MiImagen from '../assets/dont.jpg';

const Denied = ({user, userName}) => {

  return (
    <div className="mt-16">
      <Card
        textTitle="Leads"
        elementBody={
          <div className="flex flex-col items-center">
           <img className="w-60" src={MiImagen} alt="Acceso denegado"/>
           <p>No cuentas con permisos para acceder a esta sección</p>
          </div>
        }
      />
    </div>
  );
};

export default Denied;
